


import React, { useState, useEffect } from "react";
import { Box, Container, Tabs, Tab, Paper, Typography, Skeleton, Stack, Chip } from "@mui/material";

import BreadcrumbsNav from "../../components/common/BreadCrumbNav";
import MaterialFilterCard from "../../components/common/MaterialFilterCard";
import MaterialEnquiry from "./MaterialEnquiry";
import MaterialProductCard from "./MaterialProductCard";
import MaterialProductCardDetail from "./MaterialProductCardDetail";
import AboutShop from "../Material Store/AboutShop";
import ReviewRating from "../Material Store/ReviewRating";
import { material_list } from "../../api/ControllApi";
import MaterialStoreFilter from "./MaterialStoreFilter";
import MaterialStoreCard from "../../components/common/MaterialStoreCard";
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ViewListIcon from '@mui/icons-material/ViewList';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, MenuItem } from "@mui/material";
import { get_state, get_city } from "../../api/ControllApi";
import { useNavigate } from "react-router-dom";
import { ASSET_BASE } from "../../utils/baseUrls";
export default function MaterialStore() {

  const [viewClicked, setViewClicked] = useState(false);
  const [tab, setTab] = useState(0);
  const [materialList, setMaterialList] = useState([]);
  const [loading, setLoading] = useState(true);

  // Filter States
  const [filters, setFilters] = useState({
    category: "",
    sub_category: "",
    sub_sub_category: [],
    brand_id: [],
    material_name: "",
  });

  const [viewType, setViewType] = useState("grid");
  const [locationDialogOpen, setLocationDialogOpen] = useState(false);
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
  });
  const navigate = useNavigate();

  useEffect(() => {
    get_state().then(res => setStates(res?.data || []));
  }, []);

  useEffect(() => {
    if (selectedState) {
      get_city({ state_id: selectedState }).then(res => setCities(res?.data || []));
    } else {
      setCities([]);
    }
  }, [selectedState]);

  const handleProductSelect = (id, name) => {
    navigate(`/material-store/shop/${id}?material_name=${encodeURIComponent(name)}`);
  };

  const fetchMaterials = () => {
    setLoading(true);
    // Prepare params: map filters to expected API keys
    const params = {
      category: filters.category,
      sub_category: filters.sub_category,
      material_name: filters.material_name,
      page_no: page,
      per_unit: 10,
    };

    // Handle sub_sub_category[] if it's an array
    if (filters.sub_sub_category && filters.sub_sub_category.length > 0) {
      params["sub_sub_category[]"] = filters.sub_sub_category;
    }

    // Handle brand_id[] if it's an array
    if (filters.brand_id && filters.brand_id.length > 0) {
      params["brand_id[]"] = filters.brand_id;
    }

    material_list(params)
      .then(res => {
        const materialData = res?.data?.material || [];
        const paginationData = res?.data?.pagination || { current_page: 1, last_page: 1 };

        setMaterialList(Array.isArray(materialData) ? materialData : []);
        setPagination(paginationData);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchMaterials();
  }, [filters, page]);

  const handleFilterChange = (newFilters) => {
    setFilters(prev => ({ ...prev, ...newFilters }));
    setPage(1); // Reset to page 1 on filter change
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Container maxWidth={false} sx={{ width: { xs: '95%', md: '80%' }, mx: 'auto', py: 5 }}>
      <Box sx={{ mb: 3, mt: 3 }}>
        <BreadcrumbsNav />
      </Box>

      {/*DEFAULT VIEW */}
      {!viewClicked && (
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "300px 1fr" },
            gap: 3,
            mt: 3,
            mb: 2,
          }}
        >
          <Box>
            <MaterialFilterCard filters={filters} onFilterChange={handleFilterChange} />
          </Box>
          <Box>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
              {/* <ToggleButtonGroup
                value={viewType}
                exclusive
                onChange={(e, nextView) => nextView && setViewType(nextView)}
                size="small"
              >
                <ToggleButton value="list">
                  <ViewListIcon />
                </ToggleButton>
                <ToggleButton value="grid">
                  <ViewModuleIcon />
                </ToggleButton>
              </ToggleButtonGroup> */}
            </Box>

            {/* Active Filter Breadcrumbs */}
            {/* {(filters.category || (filters.brand_id && filters.brand_id.length > 0)) && (
              <Stack direction="row" spacing={1} mb={2} flexWrap="wrap">
                {filters.category && (
                  <Chip
                    label={`Category: ${filters.category}`} // Simplified, usually labels are fetched in FilterCard
                    onDelete={() => handleFilterChange({ category: "" })}
                    color="primary"
                    variant="outlined"
                  />
                )}
                {filters.brand_id && filters.brand_id.length > 0 && filters.brand_id.map(bid => (
                  <Chip
                    key={bid}
                    label={`Brand ID: ${bid}`}
                    onDelete={() => handleFilterChange({ brand_id: filters.brand_id.filter(id => id !== bid) })}
                    color="secondary"
                    variant="outlined"
                  />
                ))}
              </Stack>
            )} */}

            <Box
              sx={{
                display: "grid",
                gap: 2,
                gridTemplateColumns: viewType === "list" ? "1fr" : { xs: "1fr", sm: "1fr 1fr", md: "1fr 1fr 1fr" },
              }}
            >
              {loading
                ? Array.from({ length: 6 }).map((_, i) => (
                  <Skeleton key={i} variant="rectangular" height={220} />
                ))
                : materialList.length > 0
                  ? materialList.map(card => (
                    <MaterialProductCard
                      key={card.id}
                      name={card.material_name}
                      materialCode={card.material_code}
                      images={(() => {
                        if (card.gallery) {
                          return card.gallery.split(",").map(img => 
                            img.startsWith("http") ? img : `${ASSET_BASE}${img}`
                          ).filter(img => !img.endsWith(".mp4"));
                        }
                        return Array.isArray(card.image) ? card.image : (card.image ? [card.image] : []);
                      })()}
                      description={card.description}
                      id={card.id}
                      selectionMode={true}
                      viewType={viewType}
                      onSelect={(id) => handleProductSelect(id, card.material_name)}
                    />
                  ))
                  : (
                    <Box
                      sx={{
                        gridColumn: "1 / -1",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        minHeight: "40vh",
                        textAlign: "center",
                        width: "100%",
                        py: 5,
                      }}
                    >
                      <Box
                        component="img"
                        src="/assets/images/nodatafound.png"
                        alt="No Data Found"
                        sx={{ width: { xs: 280, sm: 320, md: 350 }, mb: 2 }}
                      />
                    </Box>
                  )}
            </Box>

            {/* PAGINATION */}
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 2,
                mt: 8,
                mb: 4,
              }}
            >
              <Typography fontSize={{ xs: 16, sm: 18, md: 20 }} color="text.secondary">
                {/* Top Products - Page {pagination.current_page} of {pagination.last_page} */}
              </Typography>

              {pagination.last_page > 1 && (
                <Stack direction="row" spacing={1} justifyContent="center">
                  {Array.from({ length: pagination.last_page }, (_, i) => i + 1).map(
                    (p) => (
                      <Button
                        key={p}
                        variant={p === page ? "contained" : "outlined"}
                        onClick={() => handlePageChange(p)}
                        sx={{
                          borderRadius: "9px",
                          bgcolor: p === page ? "#95B160" : "transparent",
                          color: p === page ? "#fff" : "#95B160",
                          borderColor: "#95B160",
                          minWidth: 40,
                          height: 40,
                          "&:hover": {
                            bgcolor: p === page ? "#7a944d" : "rgba(149, 177, 96, 0.1)",
                            borderColor: "#95B160",
                          },
                        }}
                      >
                        {p}
                      </Button>
                    )
                  )}
                </Stack>
              )}
            </Box>
          </Box>
        </Box>
      )}

    </Container>
  );
}
